var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initialState = {
    data: null,
};
var subscriptionReducer = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case 'ADD_DATA':
            return __assign(__assign({}, state), { data: payload.data });
        default:
            return state;
    }
};
export default subscriptionReducer;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/subscriptions.ts
// module id = 1461
// module chunks = 81